import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unique',
  pure: false
})

export class UniquePipe implements PipeTransform {
  transform(value: any, prop?:any): any {

        // Remove the duplicate elements
        var flags = {};
        if (value != null) {
          let uniqueArray = value.filter(function (el, index, array) {
          if (flags[el[prop]]) {
              return false;
          }
          flags[el[prop]] = true;
          return true;
        });

        return uniqueArray;
        }
    }
}


@Pipe({
  name: 'class',
  pure: false
})

export class ClassPipe implements PipeTransform {
  transform(value: any, prop?:any): any {

        // Remove the duplicate elements
        let uniqueArray = value.filter(function (el, index, array) {
          return el.constructor.name === prop;
        });

        return uniqueArray;
    }
}

@Pipe({
  name: 'attribute',
  pure: false
})

export class AttributePipe implements PipeTransform {
    transform(valArray: any, prop?:any, value?:any): any {
        // Remove the duplicate elements
        let uniqueArray = valArray.filter(function (el, index, array) {
          if(Array.isArray(value)){
              return value.indexOf(el[prop]) > -1;
          }else{
              return el[prop] === value;
          }

        });
        return uniqueArray;
    }
}

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string, props?:any): any[] {
    if(!items) return [];
    if(!searchText) return items;
      searchText = searchText.toLowerCase();
      return items.filter( it => {
          let result = false;
          if(props){
            for(let prop of props ){
              result = it[prop]?it[prop].toLocaleLowerCase().includes(searchText):null;
              if(result)
                break;
            }
          }else{
            result = it.toLocaleLowerCase().includes(searchText);
          }

          return result;

        });
    }
}

@Pipe({
  name: 'sortBy',
  pure: false
})

export class SortyByPipe implements PipeTransform {
    transform(valArray: any, prop?:any, value?:any): any {
        // Remove the duplicate elements
        let uniqueArray = valArray.sort((a: any, b: any) => {
            if (a[prop] > b[prop]) {
                return -1;
            } else if (a[prop] < b[prop]) {
                return 1;
            } else {
                return 0;
            }
        });
        return uniqueArray;
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/utils/uniquePipe.ts